<template>
  <v-container fluid>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        sort-by="section_id"
        class="elevation-1 pa-3"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Section Access Configuration</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search by section name"
              single-line
              outlined
              hide-details
              dense
            ></v-text-field>

            <v-spacer></v-spacer>
            <v-btn
              color="#0A7EA5"
              rounded
              dark
              @click="openadd()"
              :disabled="!authorize_add"
              style="margin: auto;"
            >
              ADD +
            </v-btn>
          </v-toolbar>
        </template>

        <!-- เพิ่ม custom slot สำหรับแสดง position_name เป็น chips -->
        <template v-slot:[`item.position_name`]="{ item }">
          <v-chip
            v-for="(name, index) in item.position_name"
            :key="index"
            class="ma-1"
            color="primary"
            text-color="white"
            small
          >
            {{ name }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="openeditItem(item)"
            v-if="authorize_edit"
          >
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)" v-if="authorize_del">
            mdi-delete
          </v-icon>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="getSectionData()">
            Refresh
          </v-btn>
        </template>
      </v-data-table>

      <!-- Dialog Add (เหมือนเดิม) -->
      <v-dialog v-model="dialogadd" persistent max-width="900px">
        <v-card style="padding: 1rem 0.5rem;">
          <v-card-title class="text-h5" style="margin-bottom: 1rem;"
            >Add Section Access Configuration</v-card-title
          >
          <v-card-text style="padding-bottom: 0;">
            <v-container>
              <v-row style="margin-bottom: 1rem;">
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="itemadd.section_id"
                    label="Section ID"
                    outlined
                    dense
                    hide-details
                    style="height: 55px;"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="itemadd.section_name"
                    label="Section Name"
                    outlined
                    dense
                    hide-details
                    style="height: 55px;"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete
                    v-validate="'required'"
                    :items="positionAll"
                    label="Allowed Position"
                    item-text="name"
                    item-value="id"
                    v-model="itemadd.position_id"
                    outlined
                    dense
                    multiple
                    chips
                    hide-details
                    required
                    style="height: 55px;"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="d-flex justify-center">
            <v-btn
              depressed
              width="100"
              class="mr-3 buttonblue"
              @click="savedata()"
            >
              SAVE
            </v-btn>
            <v-btn depressed outlined width="100" @click="canceladd()">
              CANCEL
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog Edit (เหมือนเดิม) -->
      <v-dialog v-model="dialogedit" persistent max-width="900px">
        <v-card style="padding: 1rem 0.5rem;">
          <v-card-title class="text-h5" style="margin-bottom: 1rem;"
            >Edit Section Access Configuration</v-card-title
          >
          <v-card-text style="padding-bottom: 0;">
            <v-container>
              <v-row style="margin-bottom: 1rem;">
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="itemedit.section_id"
                    label="Section ID"
                    outlined
                    disabled
                    dense
                    hide-details
                    style="height: 55px;"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="itemedit.section_name"
                    label="Section Name"
                    outlined
                    dense
                    hide-details
                    style="height: 55px;"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete
                    v-validate="'required'"
                    :items="positionAll"
                    label="Allowed Position"
                    item-text="name"
                    item-value="id"
                    v-model="itemedit.position_id"
                    outlined
                    dense
                    multiple
                    chips
                    hide-details
                    style="height: 55px;"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="d-flex justify-center">
            <v-btn
              depressed
              width="100"
              class="mr-3 buttonblue"
              @click="savedataedit()"
            >
              SAVE
            </v-btn>
            <v-btn depressed outlined width="100" @click="canceledit()">
              CANCEL
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <SuccessDialog
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
      />
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";

export default {
  components: {
    SuccessDialog,
  },
  data: () => ({
    positionAll: [],
    dialogAdd: false,
    text_color: "text-h5 green--text text-center",
    title: "green",
    message: "green",
    search: "",
    dialogadd: false,
    dialogedit: false,
    headers: [
      { text: "Section ID", value: "section_id" },
      { text: "Section Name", value: "section_name" },
      { text: "Position Access", value: "position_name", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    desserts: [],
    itemadd: {
      section_id: "",
      section_name: "",
      position_id: [],
      company_id: localStorage.getItem(server.COMPANYID),
    },
    itemeditid: 0,
    itemedit: {
      section_id: "",
      section_name: "",
      position_id: [],
      company_id: localStorage.getItem(server.COMPANYID),
    },
  }),

  async mounted() {
    await api.checkVersion();
    // Authorization code... (เหมือนเดิม)
    const userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    if (this.authorize_id == null || this.authorize_id == 0) {
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");
    const res_auth = await api.getAuthorize(userId, router_path);

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    if (userId && api.isLoggedIn()) {
      // Authorized
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    await this.loadPositions();
    await this.getSectionData();
  },

  methods: {
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },

    async loadPositions() {
      const result = await api.getAllPosition_By_CompanyID(
        localStorage.getItem(server.COMPANYID)
      );
      this.positionAll = result.data;
      this.$hideLoader();
    },

    async getSectionData() {
      const result = await api.getSectionAccessConfig_By_CompanyID(
        localStorage.getItem(server.COMPANYID)
      );
      // console.log(`Section Access Data: ${JSON.stringify(result.data)}`);

      // ข้อมูลที่ได้จาก backend จะมีโครงสร้างแบบนี้:
      // [
      //   {
      //     id: 1,
      //     section_id: "S1",
      //     section_name: "Approve Time Off",
      //     position_id: [1, 5, 6],
      //     position_name: ["Admin", "Manager", "Supervisor"],
      //     ...
      //   }
      // ]

      this.desserts = result.data;
      this.$hideLoader();
    },

    openadd() {
      this.itemadd = {
        section_id: "",
        section_name: "",
        position_id: [],
        company_id: localStorage.getItem(server.COMPANYID),
      };
      this.dialogadd = true;
    },

    canceladd() {
      this.dialogadd = false;
    },

    canceledit() {
      this.dialogedit = false;
    },

    async savedata() {
      if (this.itemadd.section_id == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Section ID",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemadd.section_name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Section Name",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemadd.position_id.length == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select at least one position",
          "text-h5 red--text text-center"
        );
        return;
      }

      const res_add = await api.createSectionAccessConfig(this.itemadd);
      if (res_add.status == 200 || res_add.status == 201) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Success",
          "Add data success",
          "text-h5 green--text text-center"
        );
        await this.getSectionData();
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Add data Failed",
          "text-h5 red--text text-center"
        );
      }
      this.dialogadd = false;
    },

    async openeditItem(item) {
      console.log("Edit Item:", item);

      this.itemeditid = item.id;
      this.itemedit.section_id = item.section_id;
      this.itemedit.section_name = item.section_name;

      // item.position_id จะเป็น array อยู่แล้วจาก backend
      this.itemedit.position_id = [...item.position_id]; // Clone array

      this.dialogedit = true;
    },

    async savedataedit() {
      if (this.itemedit.section_name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Section Name",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemedit.position_id.length == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select at least one position",
          "text-h5 red--text text-center"
        );
        return;
      }

      const res_update = await api.updateSectionAccessConfig(
        this.itemeditid,
        this.itemedit
      );

      if (res_update.status == 200 || res_update.status == 201) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Success",
          "Update data success",
          "text-h5 green--text text-center"
        );
        await this.getSectionData();
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Update data Failed",
          "text-h5 red--text text-center"
        );
      }
      this.dialogedit = false;
    },

    async deleteItem(item) {
      if (confirm("Are you sure you want to delete this section?")) {
        const res_delete = await api.deleteSectionAccessConfig(item.id);
        if (res_delete.status == 200 || res_delete.status == 204) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            "Delete data success",
            "text-h5 green--text text-center"
          );
          await this.getSectionData();
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Delete data Failed",
            "text-h5 red--text text-center"
          );
        }
      }
    },
  },

  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>
